import StyleOverrider from 'mrf/utils/StyleOverrider';
import tw, { styled } from 'twin.macro';

const DefaultCheckbox = styled.input`
    && {
        ${tw`flex items-center rounded shadow-sm focus:(border-primary ring ring-offset-0 ring-primary-light ring-opacity-30)`}

        ${({ readOnly, disabled }) => readOnly || disabled ? tw`border-gray-300 cursor-not-allowed text-color-disabled` : tw`cursor-pointer text-primary` }
    }
`;

const [Checkbox, setCheckboxStyle] = StyleOverrider(DefaultCheckbox);
export { Checkbox as default, DefaultCheckbox, setCheckboxStyle };
